// extracted by mini-css-extract-plugin
module.exports = {"container":"ThreeKeyPoints_container__1JmAN","point":"ThreeKeyPoints_point__1Xnh0","graphic":"ThreeKeyPoints_graphic__3ICLX"};